import {Component, OnInit, OnDestroy} from '@angular/core';
import {UntypedFormGroup, UntypedFormBuilder, Validators, FormControl} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {User} from '../../services/user/user';
import {HhgOnlineBookShipmentService} from '../hhg-online-book-shipment/hhg-online-book-shipment.service';
import {LoadingService} from '../../services/loading/loading.service';
import {UserService} from '../../services/user/user.service';
import {Carrier} from 'src/app/services/carrier/carrier';
import {AlertService} from '../../services/alert/alert.service';
import {ConfirmationModalComponent} from '../../shared/common-components/confirmation-modal/confirmation-modal.component';
import {UserProfileService} from 'src/app/services/user-profile/user-profile.service';
import {reqPackagingDateValidator} from '../hhg-online-book-shipment/validators';
import {FrtShipmentHazmatModalComponent} from 'src/app/shared/common-components/shipment/frt-shipment-item-modal/frt-shipment-item-modal.component';
import {BookShipmentRequest} from '../hhg-online-book-shipment/book-shipment';
import AppConstants, {NameAndAddressRecordType, BookShipmentStatus} from 'src/app/shared/common-components/AppConstants';
import {BehaviorSubject, forkJoin, Observable} from 'rxjs';
import {FrtShipmentSealPurchaseComponent} from '../frt-shipment-seal-purchase/frt-shipment-seal-purchase.component';
import {NameAndAddressService} from '../../services/name-and-address/name-and-address.service';
import {BillofladingAddressesComponent} from '../billoflading-addresses/billoflading-addresses.component';
import {
  FrtShipmentSealNos,
  FrtShipmentPurchaseOrder,
  NameAndAddress,
  FrtShopRatesIn
} from 'src/app/shared/common-components/common-structure';
import {CarrierService} from '../../services/carrier/carrier.service';
import {FrtShipmentPackageService} from 'src/app/services/frt-shipment-package/frt-shipment-package.service';
import {RatesSroMasterService} from '../../services/rates-sro-master/rates-sro-master.service';
import {concatMap, map, takeWhile} from 'rxjs/operators';
import {CommonValidators} from '../../shared/common-components/common-validators';
import {FrtShipAccessorialsService} from '../../services/frt-ship-accessorials/frt-ship-accessorials.service';
import moment from 'moment';
import { timepickerValidation } from './customValidationForTimePicker';
import {UserPreferencesService} from '../../services/user-preferences/user-preferences.service';
import _ from 'lodash';

@Component({
    selector: 'app-frt-online-book-shipment',
    templateUrl: './frt-online-book-shipment.component.html',
    styleUrls: ['./frt-online-book-shipment.component.css'],
    standalone: false
})
export class FrtOnlineBookShipmentComponent implements OnInit, OnDestroy {

  timeExample = null;
  otoInfo: any = null;
  disabledDates;
  private observer$ = new BehaviorSubject(true);
  accessorialTspStatus = [];
  public modalRef: BsModalRef;
  carrier: Carrier;
  isCarrierView = false; // use this field and set it to true if its TSP view
  isOneTimeShipment = false;
  isGSSPR = false;
  isFleet = false;
  expectedDeliveryDate;
  frtOnlineBookShipmentForm: UntypedFormGroup;
  validationMessages = {
    'moveDate': [
      {type: 'required', message: 'Pickup Date is required'}
    ],
    'requiredDeliveryDate': [
      {type: 'required', message: 'Delivery Date is required'}
    ],
    'declaredValue': [
      {type: 'required', message: 'Declared Value is required'}
    ]
  };


  bsModalRef: BsModalRef;
  numberOfDays: number[];
  numberOfHours: number[];
  // TODO: Verify options with Chandu
  surveyReqTypes: string[] = ['After Acceptance', 'Before Acceptance', 'No'];

  // TODO: Verify options with Chandu
  surveyTypes: string[] = ['Onsite', 'By Phone', 'None'];

  optionalTypes: string[] = ['Yes', 'No'];

  shipmentModes: string[] = ['Motor'];

  shipmentDetailsData: any = {};
  shipperInfo: User | any;
  shipmentInfo: any = {};
  shipmentCostInfo: any = {};
  bookShipmentInfo: any = {};
  ratesFrtInfo: any = {};
  rateTypesInfo: any = {};
  ratesSroInfo: any = {};
  shipmentDetailsInfo: any = {};
  carrierOrganizationInfo: any = {};
  cancelBookShipment = false;
  originAddress = '';
  destinationAddress = '';
  originCountry = '';
  destinationCountry = '';
  agencyInfo: any;
  minDate: Date;
  disabled = false;
  currentShipmentInfo: any;
  shipmentBookingStatus = '';
  bookshipmentid: any;
  isAcceptedWithQualificationByCarrier = false;
  acceptRejectionWithReason = false;
  acceptSpecifyReason = false;
  rejectSpecifyReason = false;
  nameAndAddressesData: NameAndAddress[];
  originId: number;
  destinationId: number;
  estimatedWeight: number;
  originCity: string;
  originState: string;
  originZip: string;
  destinationCity: string;
  destinationState: string;
  destinationZip: string;
  carrierId: number;
  selectedShipmentType: string;
  accessorialCost = 0;
  linehaulCalculation: string;
  allAddressExist = true;
  packagesExist = false;
  deliveryDateWarning = false;
  hazmatInd = false;
  duplicateShipment: boolean;
  initialTime: Date | undefined = new Date();
  organizationId: any;

  addressValidationRecordTypes: any = [
    'Origin', 'Destination', 'Bill To', 'Issue Office'
  ];

  carrierAcceptRefuseOptions: any = [
    'Accept',
    'Accept With Qualification',
    'Refuse',
  ];

  carrierAcceptOptions: any = [
    'Alternate Pickup Date',
    'Alternate Delivery Date',
    'Equipment Availability',
    'New Accessorial Requested',
    'Accessorial Qualified',
    'Additional Trucks Required',
    'Other',
  ];

  carrierRejectOptions: any = [
    'Equipment Not Available',
    'Staff Not Available',
    'Not Cost Efficient',
    'Shipment Pickup in an area that the TSP cannot service',
    'Shipment Delivery in an area that the TSP cannot service',
    'Weather',
    'Time Frame/Too Busy',
    'Other',
  ];
  sro: any;
  initFormData: any;
  finalFormData: any;
  disabledConfirm = true;

  constructor(private formBuilder: UntypedFormBuilder, private loader: LoadingService, private router: Router,
              private route: ActivatedRoute, private userService: UserService, private carrierService: CarrierService,
              private bookShipmentService: HhgOnlineBookShipmentService, private frtShipmentPackageService: FrtShipmentPackageService,
              private nameAndAddressService: NameAndAddressService, private modalService: BsModalService,
              private alertService: AlertService, private userProfileService: UserProfileService,
              private ratesSroMasterService: RatesSroMasterService, private userPreferencesService: UserPreferencesService,
              private frtShipAccessorialsService: FrtShipAccessorialsService) {
  }

  getInitialTime(): void {
    const time = new Date();
    time.setHours(time.getHours());
    time.setMinutes(time.getMinutes());
    this.initialTime = time;
  }

  ngOnInit() {
    this.getInitialTime();
    this.timeExample = moment().format('hh:mm');
    // url parameters
    this.selectedShipmentType = 'FRT';
    this.duplicateShipment = false;
    const bookshipmentid = this.route.snapshot.queryParamMap.get('bookshipmentid');
    this.bookshipmentid = bookshipmentid;
    if (this.route.snapshot.queryParamMap.get('duplicateShipment') !== null &&
      this.route.snapshot.queryParamMap.get('duplicateShipment') !== undefined) {
      if (this.route.snapshot.queryParamMap.get('duplicateShipment') === '1') {
        this.duplicateShipment = true;
      }
    }
    this.createFrtOnlineBookShipmentForm();
    this.bookShipmentService.getShipmentsObservable().pipe(takeWhile(() => this.observer$.value)).subscribe(data => {
      console.log(this.currentShipmentInfo);
      this.currentShipmentInfo = data;
      //  this.loader.hide();
    }, (error) => {
      this.loader.hide();
      console.log(error);
    });

    this.loader.show();
    console.log(this.currentShipmentInfo);
    if (!AppConstants.isNotNullCondition(this.currentShipmentInfo) || Object.keys(this.currentShipmentInfo).length === 0) {
      // Retrieve shipment data from database
      this.getShipmentInfoByBookShipmentId(bookshipmentid);
    } else {
      this.shipmentInfo = this.currentShipmentInfo;
      this.convertDateToUTCDate();
      this.bookShipmentInfo = this.shipmentInfo.bookShipmentsEntity;
      if (this.bookShipmentInfo.oneTimeOnly === 1) {
        this.bookShipmentService.getShipmentInfoByBookShipmentId(this.bookshipmentid)
          .pipe(takeWhile(() => this.observer$.value)).subscribe(data => {
          this.shipmentDetailsData = data;
        }, error => {
          this.loader.hide();
          console.log('There was an error retrieving shipment info by book shipment id' + error);
          this.alertService.error('Error retrieving shipment details');
        }, () => {
          this.loadInitialData();
        });
      } else {
        this.shipmentDetailsData = this.currentShipmentInfo;
        this.loadInitialData();
        this.bookShipmentService.setShipmentsObservable(null);
      }
    }
    this.minDate = new Date();
    this.userService.getCurrentUserObservable()
      .pipe(takeWhile(() => this.observer$.value)).subscribe(currentUser => {
      this.organizationId = currentUser.organizationId;
      this.loadCarrierView(currentUser);
    }, (error) => {
      this.loader.hide();
      console.log(error);
    });
    window.scrollTo(0, 0);
  }

  convertDateToUTCDate(){
    let moveDate = new Date(this.shipmentInfo.moveDate);
    let requiredDeliveryDate = new Date(this.shipmentInfo.requiredDeliveryDate);
    this.shipmentInfo.moveDate = moveDate.toUTCString();
    this.shipmentInfo.requiredDeliveryDate = requiredDeliveryDate.toUTCString();
  }

  loadCarrierView(currentUser) {
    if (AppConstants.isNotNullCondition(currentUser)) {
      const carrierRoles = AppConstants.getCarrierRolesArray();
      if (currentUser.roles.some(role => carrierRoles.indexOf(role.name) >= 0)) {
        this.isCarrierView = true;
      }
    }
  }

  generateDefaultTime(){
    var x = new Date();
    x.setHours(0,0,0,0);
    return x;
  }

  createFrtOnlineBookShipmentForm() {
    this.frtOnlineBookShipmentForm = this.formBuilder.group({
      moveDate: new FormControl('', Validators.required),
      declaredValue: new FormControl('', [CommonValidators.numeric,Validators.required]),
      requiredDeliveryDate: new FormControl('', Validators.required),
      // pickupTime: new FormControl('', [timepickerValidation()]),
      pickupTimeFrom: new FormControl(this.generateDefaultTime(), [timepickerValidation()]),
      pickupTimeFromMeridian: new FormControl('AM'),
      pickupTimeTo: new FormControl(this.generateDefaultTime(), [timepickerValidation()]),
      pickupTimeToMeridian: new FormControl('AM'),
      // deliveryTime: new FormControl('', [timepickerValidation()]),
      deliveryTimeFrom: new FormControl(this.generateDefaultTime(), [timepickerValidation()]),
      deliveryTimeFromMeridian : new FormControl('AM'),
      deliveryTimeTo: new FormControl(this.generateDefaultTime(), [timepickerValidation()]),
      deliveryTimeToMeridian: new FormControl('AM'),
      tspProBillNo: new FormControl(''),
      totalCost: new FormControl('', [CommonValidators.currency, Validators.required]),
      preMoveSurveyType: new FormControl(''),
      preMoveSurveyReqd: new FormControl(''),
      tspResponseInDays: new FormControl(''),
      tspResponseInHours: new FormControl(''),
      bookingType: new FormControl(''),
      additionalComments: new FormControl(''),
      tspAdditionalComments: new FormControl(''),
      hazmatIndicator: new FormControl(''),
      hazmatContactInfo: new FormControl(''),
      agencyLocationCode: new FormControl(''),
      agencyShipmentIdNo: new FormControl(''),
      shipmentMode: new FormControl('Motor'),
      carrierAcceptRefuseStatus: new FormControl(''),
      carrierAcceptOption: new FormControl(''),
      carrierRefuseOption: new FormControl(''),
      carrierAcceptReason: new FormControl(''),
      carrierRefuseReason: new FormControl(''),
      inputEstimatedWeight: new FormControl('')
    });
  }

  /**
   * @description To get shipment details by book shipment id
   * @param bookshipmentid: Book shipment id of the shipment
   */
  getShipmentInfoByBookShipmentId(bookshipmentid) {
    this.bookShipmentService.getShipmentInfoByBookShipmentId(bookshipmentid)
      .pipe(takeWhile(() => this.observer$.value)).subscribe(data => {
      this.shipmentDetailsData = data;
    }, error => {
      this.loader.hide();
      console.log('There was an error retrieving shipment info by book shipment id' + error);
      this.alertService.error('Error retrieving shipment details');
    }, () => {
      const request = JSON.parse(sessionStorage.getItem('shipmentId'));
      if (request !== null && request !== undefined) {
        let newShipmentInfo: any;
        setTimeout(() => {
          this.bookShipmentService.copyFreightAddressDetails(request, this.shipmentDetailsData.shipmentsInfoId)
            .pipe(takeWhile(() => this.observer$.value)).subscribe(result => {
            newShipmentInfo = result;
          }, (error) => {
            console.log('There was an error copying the addresses', error);
            this.alertService.error('Error copying address details');
          }, () => {
            if (newShipmentInfo != null) {
              console.log('this is Requery shipment');
              this.shipmentDetailsData = newShipmentInfo;
              sessionStorage.removeItem('shipmentId');
              this.loadInitialData();
            } else {
              this.alertService.error('Error copying address details');
              this.loadInitialData();
            }

          });
        }, 1000);
      } else {
        this.loadInitialData();
      }
    });
    //this.loader.hide();
  }

  /**
   * @description Prepopulates selected data from the previous page
   */

  loadInitialData() {
    this.loader.show();
    this.numberOfDays = Array(10).fill(0).map((x, i) => i + 1);
    this.numberOfHours = Array(11).fill(0).map((x, i) => i + 2);
    const form = this.frtOnlineBookShipmentForm;

    this.shipmentInfo = this.shipmentDetailsData;
    this.bookShipmentInfo = this.shipmentInfo.bookShipmentsEntity;
    if (this.bookShipmentInfo.oneTimeOnly === 1) {
      this.isOneTimeShipment = true;
    }
    this.shipmentCostInfo = this.shipmentInfo.frtShipmentsCostInfoEntity;
    this.carrierId = AppConstants.isNotNullCondition(this.shipmentCostInfo) ? this.shipmentCostInfo.carrierId : null;
    this.shipmentDetailsInfo = this.shipmentInfo.frtShipmentDetailsEntity;
    this.ratesFrtInfo = this.shipmentCostInfo ? this.shipmentCostInfo.ratesFrtEntity : this.ratesFrtInfo;
    this.rateTypesInfo = this.ratesFrtInfo ? this.ratesFrtInfo.rateTypesEntity : this.rateTypesInfo;
    this.ratesSroInfo = this.shipmentInfo.ratesSroMasterEntity;
    if (!this.isOneTimeShipment) {
      this.frtShipmentPackageService.setSroIDFromBookShipment(this.ratesSroInfo.sroId);
    }
    this.shipperInfo = this.bookShipmentInfo.userEntity;
    this.loadCarrierDetails(this.carrierId);
    // this.loadAgencyDetails(this.bookShipmentInfo.userId);
    const organizationEntity = this.bookShipmentInfo.organizationEntity;
    if (AppConstants.isNotNullCondition(organizationEntity) && AppConstants.isNotNullCondition(organizationEntity.agencyCustomerEntity)) {
      this.agencyInfo = organizationEntity.agencyCustomerEntity.agencyMasterEntity;
    }
    const addressInfo = this.shipmentInfo.nameAndAddressEntity;

    if (AppConstants.isNotNullCondition(this.ratesSroInfo) && AppConstants.isNotNullCondition(this.ratesSroInfo.sroId)  && this.ratesSroInfo.sroId == 'GSSPR') {
      this.isGSSPR = true;
    }

    addressInfo.forEach(addressObj => {
      if (addressObj.recordType !== 'Issue Office') {
        const country = AppConstants.isNotNullCondition(addressObj.countryEntity.stateCountryName) ? addressObj.countryEntity.stateCountryName : '';
        const city = AppConstants.isNotNullCondition(addressObj.city) ? addressObj.city : '';
        const state = AppConstants.isNotNullCondition(addressObj.stateEntity) ? addressObj.stateEntity.stateCountryCode2Digit : '';
        const zip = AppConstants.isNotNullCondition(addressObj.zipCode) ? addressObj.zipCode : '';

        if (addressObj.recordType === NameAndAddressRecordType.ORIGIN) {
          if (AppConstants.isNotNullCondition(city) && AppConstants.isNotNullCondition(state) && AppConstants.isNotNullCondition(zip)) {
            this.originAddress = city + ',' + state + '(' + zip + ')';
          }

          this.originCity = city;
          this.originState = state;
          this.originZip = zip;
          if (country != 'UNITED STATES') {
            this.originCountry = country;
          }
        } else if (addressObj.recordType === NameAndAddressRecordType.DESTINATION) {
          if (AppConstants.isNotNullCondition(city) && AppConstants.isNotNullCondition(state) && AppConstants.isNotNullCondition(zip)) {
            this.destinationAddress = city + ',' + state + '(' + zip + ')';
          }

          this.destinationCity = city;
          this.destinationState = state;
          this.destinationZip = zip;
          if (country != 'UNITED STATES') {
            this.destinationCountry = country;
          }
        }
      }
    });


    // Pre-populate form data
    form.controls['moveDate'].setValue(this.shipmentInfo.moveDate != null ? new Date(this.shipmentInfo.moveDate) : new Date(this.shipmentInfo.moveDate));
    this.assignValueForTimePicker(this.shipmentInfo.moveTimeFrom, form.controls['pickupTimeFrom'], form.controls['pickupTimeFromMeridian']);
    this.assignValueForTimePicker(this.shipmentInfo.moveTimeTo, form.controls['pickupTimeTo'], form.controls['pickupTimeToMeridian']);
    // this.setValueForTime(this.shipmentInfo.moveDate, form.controls['pickupTime']);
    form.controls['requiredDeliveryDate'].setValue(this.shipmentInfo.requiredDeliveryDate != null ? new Date(this.shipmentInfo.requiredDeliveryDate) : new Date(this.shipmentInfo.requiredDeliveryDate));
    this.assignValueForTimePicker(this.shipmentInfo.deliveryTimeFrom, form.controls['deliveryTimeFrom'], form.controls['deliveryTimeFromMeridian']);
    this.assignValueForTimePicker(this.shipmentInfo.deliveryTimeTo, form.controls['deliveryTimeTo'], form.controls['deliveryTimeToMeridian']);
    // this.setValueForTime(this.shipmentInfo.requiredDeliveryDate, form.controls['deliveryTime']);
    // this.assignValueForTimePicker(this.shipmentInfo.deliveryTimeFrom, form.controls['deliveryTimeFrom']);
    // this.assignValueForTimePicker(this.shipmentInfo.deliveryTimeTo, form.controls['deliveryTimeTo']);
    form.controls['totalCost'].setValue(this.shipmentCostInfo.totalCost);
    form.controls['declaredValue'].setValue(this.shipmentInfo.declaredValue);
    form.controls['hazmatIndicator'].setValue(this.shipmentInfo.hazmatIndicator === 1 ? 'Yes' : 'No');
    form.controls['hazmatContactInfo'].setValue(this.shipmentInfo.hazmatContactInfo);
    form.controls['preMoveSurveyType'].setValue(this.bookShipmentInfo.preMoveSurveyType);
    form.controls['preMoveSurveyReqd'].setValue(this.bookShipmentInfo.preMoveSurveyReqd);
    form.controls['tspResponseInDays'].setValue(this.bookShipmentInfo.tspResponseInDays);
    form.controls['tspResponseInHours'].setValue(this.bookShipmentInfo.tspResponseInHours);
    form.controls['additionalComments'].setValue(this.bookShipmentInfo.additionalComments);
    form.controls['tspAdditionalComments'].setValue(this.bookShipmentInfo.tspAdditionalComments);
    form.controls['bookingType'].setValue(this.bookShipmentInfo.bookingType === 'Offline' ? true : false);
    form.controls['inputEstimatedWeight'].setValue(this.shipmentInfo.weight);

    if (this.bookShipmentInfo.bookingStatus === BookShipmentStatus.CANCELLED ||
      this.bookShipmentInfo.bookingStatus === BookShipmentStatus.REFUSED) {
      this.disabled = true;
    }

    if (AppConstants.isNotNullCondition(this.shipmentDetailsInfo)) {
      form.controls['agencyLocationCode'].setValue(this.shipmentDetailsInfo.agencyLocationCode);
      form.controls['tspProBillNo'].setValue(this.shipmentDetailsInfo.tspProBillNo);
      form.controls['agencyShipmentIdNo'].setValue(this.shipmentDetailsInfo.agencyShipmentIdNo);
      // form.controls['shipmentMode'].setValue(this.shipmentDetailsInfo.shipmentMode);
    }


    // populate required delivery date // to do CATMTMSS-3014
    if (this.shipmentInfo.requiredDeliveryDate === null || this.shipmentInfo.requiredDeliveryDate === "") {
      this.updateDeliveryDate(this.shipmentInfo.moveDate);
      // this.userPreferencesService.getAllFederalHolidays().subscribe(holidays => {
      //   this.disabledDates = holidays.map(x => new Date(x + ' 00:00:00'));
      // this.populateDeliveryDate(this.shipmentInfo.moveDate, this.shipmentInfo.miles, this.rateTypesInfo.rateTypeId);
      // });
    }

    // if (this.isCarrierView) {
    if (this.bookShipmentInfo.bookingStatus === BookShipmentStatus.ACCEPTED_WITH_QUALIFICATION) {
      form.controls['carrierAcceptRefuseStatus'].setValue('Accept With Qualification');
      form.controls['carrierAcceptOption'].setValue(this.bookShipmentInfo.refusalOrQualificationReason);
      form.controls['carrierAcceptReason'].setValue(this.bookShipmentInfo.refusalOrQualificationRemarks);
      this.acceptRejectionWithReason = true;
      this.isAcceptedWithQualificationByCarrier = true;
      // if (this.bookShipmentInfo.refusalOrQualificationReason) {
      this.acceptSpecifyReason = true;
      // }

    } else if (this.bookShipmentInfo.bookingStatus === BookShipmentStatus.REFUSED) {
      form.controls['carrierAcceptRefuseStatus'].setValue('Refuse');
      form.controls['carrierRefuseOption'].setValue(this.bookShipmentInfo.refusalOrQualificationReason);
      form.controls['carrierRefuseReason'].setValue(this.bookShipmentInfo.refusalOrQualificationRemarks);
      this.acceptRejectionWithReason = true;
      this.isAcceptedWithQualificationByCarrier = false;
      // if (this.bookShipmentInfo.refusalOrQualificationReason === 'Other') {
      this.rejectSpecifyReason = true;
      // }
    } else {
      form.controls['carrierAcceptRefuseStatus'].setValue('Accept');
    }

    if (this.isCarrierView && this.bookShipmentInfo.bookingType === 'Online' &&
      this.bookShipmentInfo.bookingStatus === BookShipmentStatus.PENDING &&
      AppConstants.isNotNullCondition(this.bookShipmentInfo.confirmationDate)) {
      const confirmDate = new Date(this.bookShipmentInfo.confirmationDate);
      if (AppConstants.isNotNullCondition(this.bookShipmentInfo.tspResponseInDays)) {
        confirmDate.setDate(confirmDate.getDate() + this.bookShipmentInfo.tspResponseInDays);
      } else if (AppConstants.isNotNullCondition(this.bookShipmentInfo.tspResponseInHours)) {
        confirmDate.setHours(confirmDate.getHours() + this.bookShipmentInfo.tspResponseInHours);
      }
      if (confirmDate < new Date()) {
        this.alertService.warn('Shipment Request has been expired as you did not respond on time');
        this.bookShipmentInfo.bookingStatus = BookShipmentStatus.EXPIRED;
        this.disabled = true;
        this.saveShipment(null);
      }
    }
    // }

    this.validateAndConfirmShipment('N');
    if (!this.isOneTimeShipment) {
      this.setUspsZipAndAccessorials();
    } else {
      this.loader.hide();
      // this.alertService.success('Successfully retrieved shipment details.');
      if (this.duplicateShipment === true) {
        this.alertService.warn('Successfully retrieved shipment details. Please verify addresses and financial informations for the duplicated shipment');
      }
    }
    //  else if(this.isCarrierView) {
    //   this.getAccessorialsList(this.shipmentInfo.shipmentsInfoId);
    // }
    if (this.shipmentInfo.updateProgram === 'FRT(OTO)-query-page') {
      this.otoInfo = this.shipmentInfo.otoShipmentContactInfoEntity;
    }
    this.onValidationChangesOfForm();
    this.loader.hide();
  }

  setValueForTime(dataTime : any, formControl){
    if(dataTime){
      const time = new Date(dataTime);
      time.setHours(new Date(dataTime).getHours());
      time.setMinutes(new Date(dataTime).getMinutes());
      formControl.setValue(time);
    }else{
      const time = new Date();
      formControl.setValue(time);
    }
  }

  assignValueForTimePicker(timeOnly: any, formControl, formControlMeridian){
    if(timeOnly){
      const currentTime = new Date();
      let indicator = "AM";
      const arrTimeHour = timeOnly.split(':');
      currentTime.setHours(arrTimeHour[0]);
      if(arrTimeHour[1].includes(' ')){
        const hrsAndIndicator = arrTimeHour[1].split(' ');
        currentTime.setMinutes(hrsAndIndicator[0]);
        indicator = hrsAndIndicator[1];
      }else{
        currentTime.setMinutes(arrTimeHour[1]);
      }
      formControlMeridian.setValue(indicator);
      formControl.setValue(currentTime);
    }
  }

  populateDeliveryDate(moveDate, miles, rateTypeId, sroInfo) {
    /*    const disabledDates = [new Date('2020-01-01 00:00:00'), new Date('2020-01-20 00:00:00'), new Date('2020-02-17 00:00:00'), new Date('2020-05-25 00:00:00'),
          new Date('2020-07-03 00:00:00'), new Date('2020-09-07 00:00:00'), new Date('2020-10-12 00:00:00'), new Date('2020-11-11 00:00:00'),
          new Date('2020-11-26 00:00:00'), new Date('2020-12-25 00:00:00'), new Date('2021-01-01 00:00:00'), new Date('2021-01-18 00:00:00'), new Date('2021-02-15 00:00:00'),
          new Date('2021-05-31 00:00:00'), new Date('2021-07-05 00:00:00'), new Date('2021-09-06 00:00:00'), new Date('2021-10-11 00:00:00'),
          new Date('2021-11-11 00:00:00'), new Date('2021-11-25 00:00:00'), new Date('2021-12-24 00:00:00'), new Date('2021-12-31 00:00:00'),
          new Date('2022-01-17 00:00:00'), new Date('2022-02-21 00:00:00'), new Date('2022-05-30 00:00:00'), new Date('2022-07-04 00:00:00'), new Date('2022-09-05 00:00:00'),
          new Date('2022-10-10 00:00:00'), new Date('2022-11-11 00:00:00'), new Date('2022-11-24 00:00:00'), new Date('2022-12-26 00:00:00'),
        ];*/
    const rateType = rateTypeId === 19 ? 'LTL' : 'TL';
    if (AppConstants.isNotNullCondition(sroInfo)) {
      this.sro = sroInfo.sroId;
    } else {
      this.sro = '';
    }

    let daysToAdd = 0;
    if (rateType === 'LTL') {
      if (miles <= 500) {
        daysToAdd = 3;
      } else if (miles > 500 && miles <= 1000) {
        daysToAdd = 4;
      } else if (miles > 1000 && miles <= 1500) {
        daysToAdd = 5;
      } else if (miles > 1500 && miles <= 2000) {
        daysToAdd = 6;
      } else if (miles > 2000) {
        daysToAdd = 7;
      }
    } else if (rateType === 'TL' && this.sro !== 'GSSPR') {
      if (miles <= 500) {
        daysToAdd = 1;
      } else if (miles > 500 && miles <= 1000) {
        daysToAdd = 2;
      } else if (miles > 1000 && miles <= 1500) {
        daysToAdd = 3;
      } else if (miles > 1500 && miles <= 2000) {
        daysToAdd = 4;
      } else if (miles > 2000 && miles <= 2500) {
        daysToAdd = 5;
      } else if (miles > 2500) {
        daysToAdd = 6;
      }
    } else if (rateType === 'TL' && this.sro === 'GSSPR') {
      daysToAdd = 8;
    }
    const requiredDeliveryDate = new Date(new Date(moveDate).setHours(0, 0, 0, 0));
    this.expectedDeliveryDate = this.calcWorkingDays(requiredDeliveryDate, daysToAdd, this.disabledDates);
    this.frtOnlineBookShipmentForm.controls['requiredDeliveryDate'].setValue(this.expectedDeliveryDate);
  }

  calcWorkingDays(fromDate, days, disabledDates) {
    let count = 0;
    while (count < days) {
      fromDate.setDate(fromDate.getDate() + 1);
      const isHoliday: boolean = this.calculateBusinessDays(fromDate, disabledDates);
      if (fromDate.getDay() !== 0 && fromDate.getDay() !== 6 && !isHoliday) { // Skip weekends and holidays
        count++;
      }
    }
    return fromDate;
  }

  // skip holidays
  calculateBusinessDays(fromDate, disabledDates) {
    let value: any;
    disabledDates.forEach(x => {
      if (x.getTime() === fromDate.getTime()) {
        value = true;
      } else if (!value) {
        value = false;
      }
    });
    return value;
  }

  /**
   * @description excludes the dates if it falls under disabled dates array, if the evaluated date is saturday adds 2 more days to make it a weekday, if the
   * evaluated date is sunday adds one day to make a weekday.
   */
  evaluateDeliveryDate(expectedDeliveryDate, disabledDates) {
    if (disabledDates.indexOf(expectedDeliveryDate) > -1) {
      expectedDeliveryDate.setDate(expectedDeliveryDate.getDate() + 1);
    }
    if (expectedDeliveryDate.getDay() === 6) {
      expectedDeliveryDate.setDate(expectedDeliveryDate.getDate() + 2);
    } else if (expectedDeliveryDate.getDay() === 0) {
      expectedDeliveryDate.setDate(expectedDeliveryDate.getDate() + 1);
    } else {
      expectedDeliveryDate.setDate(expectedDeliveryDate.getDate());
    }
    return expectedDeliveryDate;
  }

  getAccessorialsList(shipmentsInfoId) {
    this.frtShipAccessorialsService.findByShipment(shipmentsInfoId)
      .pipe(takeWhile(() => this.observer$.value)).subscribe(data => {
      if (AppConstants.isNotNullCondition(data)) {
        data.forEach(accessorial => {
          this.accessorialCost = this.accessorialCost + accessorial.accessorialCost;
          this.accessorialTspStatus.push(accessorial.tspRequest);
        });
      }
    }, _error => {
      this.loader.hide();
      this.alertService.error('Error retrieving accessorials');
    }, () => {
      this.calculateAndUpdateResults(this.shipmentInfo.moveDate, false);
    });
    this.loader.hide();
  }

  /**
   * @description To get carrier details
   * @param carrierId
   */
  loadCarrierDetails(carrierId) {
    if (carrierId) {
      this.carrierService.getCarrierByCarrierId(carrierId).subscribe(data => {
        if (AppConstants.isNotNullCondition(data)) {
          this.carrier = data;
          // this.organizationId = this.carrier.organizationId;
          if (this.carrier.carrierContactInfoEntity.length !== 0) {
            for (let i = 0; i < this.carrier.carrierContactInfoEntity.length; i++) {
              if (this.carrier.carrierContactInfoEntity[i].contactType === 'FRT') {
                this.carrierOrganizationInfo = this.carrier.carrierContactInfoEntity[i];
                break;
              } else {
                this.carrierOrganizationInfo = this.carrier.organizationEntity;
              }
            }
          } else {
            this.carrierOrganizationInfo = this.carrier.organizationEntity;
          }
        }
      }, error => {
        this.loader.hide();
        console.log('There was an error retrieving TSP details =>' + error);
        this.alertService.error('Error retrieving TSP details');
      });
      this.loader.hide();
    }
  }

  /**
   * @description To get agency/bureau details
   * @param userId
   */
  // loadAgencyDetails(userId) {
  //   if (userId) {
  //     this.userProfileService.getUser(userId).subscribe(user => {
  //       if (AppConstants.isNotNullCondition(user) && AppConstants.isNotNullCondition(user.organizationEntity)
  //       && AppConstants.isNotNullCondition(user.organizationEntity.agencyCustomerEntity)) {
  //         this.agencyInfo = user.organizationEntity.agencyCustomerEntity.agencyMasterEntity;
  //       }
  //     }, error => {
  //       this.loader.hide();
  //       console.log('There was an error retrieving agency details =>' + error);
  //       this.alertService.error('Error retrieving agency details');
  //     });
  //   }
  // }

  /**
   * @description saves shipment details
   */
  saveShipment(btnCtrl) {
    if (this.cancelBookShipment) {
      this.shipmentInfo.bookShipmentsEntity.bookingStatus = BookShipmentStatus.CANCELLED;
      this.frtBookShipmentSave(btnCtrl);
    }
    if (!this.isCarrierView && !this.frtOnlineBookShipmentForm.valid) {
      this.validateAllFormFields(this.frtOnlineBookShipmentForm);
    } else if (!this.cancelBookShipment) {
      this.prepareShipmentData(btnCtrl);
      this.frtBookShipmentSave(btnCtrl);
    }
  }

  validateAllFormFields(formGroup: UntypedFormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({onlySelf: true});
      } else if (control instanceof UntypedFormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  prepareDateTime(dateVal: any, timeVal : any){
    if(dateVal === null || timeVal === null){
      return null;
    }else{
      const finalDateTime = new Date(dateVal).setHours(new Date(timeVal).getHours(), new Date(timeVal).getMinutes(), 0);
      return  new Date(finalDateTime);
    }
  }

  prepareTime(value: any, indicator: any){
    if(value){
      var getHours = value.getHours();
      var getMins = value.getMinutes();
      return ("0" + getHours).slice(-2) + ':' + ("0" + getMins).slice(-2) + ' ' + indicator ;
    }else{
      return '00:00 AM';
    }
  }
  /**
   * @description prepares data and saves shipment details
   */
  prepareShipmentData(btnCtrl) {
    const formValues = this.frtOnlineBookShipmentForm.value;
    const bse = this.shipmentInfo.bookShipmentsEntity;
    if (!this.isCarrierView) {
      this.shipmentInfo.moveDate = formValues.moveDate;
      // this.prepareDateTime(formValues.moveDate, formValues.pickupTime);
      this.shipmentInfo.requiredDeliveryDate = formValues.requiredDeliveryDate;
      // this.prepareDateTime(formValues.requiredDeliveryDate, formValues.deliveryTime);
     // this.shipmentCostInfo.totalCost = formValues.totalCost;
      this.shipmentInfo.declaredValue = formValues.declaredValue;
      this.shipmentInfo.moveTimeFrom = this.prepareTime(formValues.pickupTimeFrom, formValues.pickupTimeFromMeridian);
      this.shipmentInfo.moveTimeTo = this.prepareTime(formValues.pickupTimeTo, formValues.pickupTimeToMeridian);
      this.shipmentInfo.deliveryTimeFrom = this.prepareTime(formValues.deliveryTimeFrom, formValues.deliveryTimeFromMeridian);
      this.shipmentInfo.deliveryTimeTo = this.prepareTime(formValues.deliveryTimeTo, formValues.deliveryTimeToMeridian);
      // this.shipmentInfo.hazmatIndicator = formValues.hazmatIndicator === 'Yes' ? 1 : 0;
      this.hazmatInd ? (this.shipmentInfo.hazmatIndicator = 1) :
        (this.shipmentInfo.hazmatIndicator = 0);

      this.shipmentInfo.hazmatContactInfo = formValues.hazmatContactInfo;
      bse.preMoveSurveyType = formValues.preMoveSurveyType;
      bse.preMoveSurveyReqd = formValues.preMoveSurveyReqd;
      if (!this.isOneTimeShipment) {
        bse.tspResponseInDays = formValues.tspResponseInDays;
        bse.tspResponseInHours = formValues.tspResponseInHours;
        bse.bookingType = formValues.bookingType === true ? 'Offline' : 'Online';
        bse.additionalComments = formValues.additionalComments;
      }
      bse.bookingStatus = AppConstants.isNotNullCondition(this.shipmentBookingStatus) ? this.shipmentBookingStatus :
        this.shipmentInfo.bookShipmentsEntity.bookingStatus;
    }

    if (this.isCarrierView) {
      bse.tspAdditionalComments = formValues.tspAdditionalComments;
      if (formValues.carrierAcceptRefuseStatus && btnCtrl === 'confirm') {
        if (this.acceptRejectionWithReason && this.isAcceptedWithQualificationByCarrier) {
          bse.bookingStatus = BookShipmentStatus.ACCEPTED_WITH_QUALIFICATION;
          bse.acceptDate = new Date();
          bse.refusalOrQualificationReason = formValues.carrierAcceptOption;
          bse.refusalOrQualificationRemarks = formValues.carrierAcceptReason;
        } else if (this.acceptRejectionWithReason && !this.isAcceptedWithQualificationByCarrier) {
          bse.bookingStatus = BookShipmentStatus.REFUSED;
          bse.refusalDate = new Date();
          bse.refusalOrQualificationReason = formValues.carrierRefuseOption;
          bse.refusalOrQualificationRemarks = formValues.carrierRefuseReason;
        } else if (formValues.carrierAcceptRefuseStatus === 'Accept') {
          bse.bookingStatus = BookShipmentStatus.ACCEPTED;
          bse.acceptDate = new Date();
        }
      }
    }
    this.shipmentInfo.bookShipmentsEntity = bse;

    const shipDetails = this.shipmentInfo.frtShipmentDetailsEntity;
    shipDetails.agencyShipmentIdNo = formValues.agencyShipmentIdNo;
    shipDetails.agencyLocationCode = formValues.agencyLocationCode;
    shipDetails.shipmentMode = formValues.shipmentMode;
    shipDetails.tspProBillNo = formValues.tspProBillNo;
    this.shipmentDetailsInfo = shipDetails;
  }

  /**
   * @description Saves shipment details
   */
  frtBookShipmentSave(btnCtrl) {
    const shipmentReq = new BookShipmentRequest();
    shipmentReq.shipmentInfo = this.shipmentInfo;
    shipmentReq.shipmentCostInfo = this.shipmentCostInfo;
    if(this.isOneTimeShipment) {
      shipmentReq.shipmentCostInfo.totalCost = this.frtOnlineBookShipmentForm.value.totalCost;
    }
    shipmentReq.control = btnCtrl;
    if (shipmentReq.shipmentInfo.bookShipmentsEntity.bookingStatus === 'Cancelled' ) {
      shipmentReq.control = BookShipmentStatus.CANCELLED ;
    }
    this.loader.show();
    this.bookShipmentService.saveShipment(shipmentReq).pipe(takeWhile(() => this.observer$.value)).subscribe(result => {
    }, (error) => {
      console.log('Error saving shipment details' + error);
      this.loader.hide();
    }, () => {
      this.loader.hide();
      if (this.bookShipmentInfo.bookingStatus != BookShipmentStatus.EXPIRED) {
        this.alertService.success('Successfully saved shipment details');
        this.router.navigate(['/', 'shipmentcontrolreview'], {
          queryParams: {
            bookshipmentid: this.shipmentInfo.bookShipmentsEntity.bookShipmentId
          }
        });
      }
    });
  }

  /**
   * @description On change booking type event
   */
  changeBookingType(eventObj) {
    if (eventObj.target.checked) {
      this.frtOnlineBookShipmentForm.controls['tspResponseInDays'].setValue(null);
      this.frtOnlineBookShipmentForm.controls['tspResponseInHours'].setValue(null);
    } else {
      this.frtOnlineBookShipmentForm.controls['tspResponseInHours'].setValue(12);
    }
  }

  /**
   * @description On change TSP Response event
   */
  changeTspResponse(eventObj) {
    if (eventObj.target.value && eventObj.target.id === 'tspResponseInDays') {
      this.frtOnlineBookShipmentForm.controls['bookingType'].setValue(false);
      this.frtOnlineBookShipmentForm.controls['tspResponseInHours'].setValue(null);
    }
    if (eventObj.target.value && eventObj.target.id === 'tspResponseInHours') {
      this.frtOnlineBookShipmentForm.controls['bookingType'].setValue(false);
      this.frtOnlineBookShipmentForm.controls['tspResponseInDays'].setValue(null);
    }
  }

  /**
   * @description Dates Validation
   */
  bsValueChange(eventObj, frmCtrl) {
    if (frmCtrl === 'requiredDeliveryDate') {
      const formDeliveryDate = this.frtOnlineBookShipmentForm.get('requiredDeliveryDate').value;
      this.frtOnlineBookShipmentForm.get(frmCtrl).setValidators([Validators.required, reqPackagingDateValidator(frmCtrl,
        this.frtOnlineBookShipmentForm.get('moveDate').value, null, eventObj)]);
      this.frtOnlineBookShipmentForm.get('moveDate').setErrors(null);
      if (AppConstants.isNotNullCondition(eventObj) && AppConstants.isNotNullCondition(formDeliveryDate) &&
        new Date(eventObj).toLocaleDateString() != new Date(this.expectedDeliveryDate).toLocaleDateString()) {
        this.deliveryDateWarning = true;
      }
    } else if (frmCtrl === 'moveDate') {
      this.frtOnlineBookShipmentForm.get('requiredDeliveryDate').setErrors(null);
      const formMoveDate = this.frtOnlineBookShipmentForm.get('moveDate').value;
      if (this.shipmentInfo.requiredDeliveryDate === null || this.shipmentInfo.requiredDeliveryDate === "")  this.updateDeliveryDate(formMoveDate);
      const initMoveDate = this.shipmentInfo.moveDate;
      if (AppConstants.isNotNullCondition(initMoveDate) && AppConstants.isNotNullCondition(formMoveDate) && ((new Date(formMoveDate)).getTime() !== (new Date(initMoveDate)).getTime())) this.updateDeliveryDate(formMoveDate);
      if(AppConstants.isNotNullCondition(formMoveDate)){
        this.frtOnlineBookShipmentForm.get(frmCtrl).setValidators([Validators.required, reqPackagingDateValidator(frmCtrl,
          eventObj, null, this.frtOnlineBookShipmentForm.get('moveDate').value)]);

        if (AppConstants.isNotNullCondition(eventObj) && AppConstants.isNotNullCondition(formMoveDate)) {
          this.deliveryDateWarning = false;
          if (!this.isOneTimeShipment) {
            this.loader.show();
            this.calculateAndUpdateResults(eventObj, true);
          }
        }
      }
    }
  }

  updateDeliveryDate(formMoveDate: any) {
    this.userPreferencesService.getAllFederalHolidays().subscribe(holidays => {
      this.disabledDates = holidays.map(x => new Date(x + ' 00:00:00'));
      this.populateDeliveryDate(formMoveDate, this.shipmentInfo.miles, this.rateTypesInfo.rateTypeId, this.ratesSroInfo);
    });
  }

  onChangeEstimatedWeight() {
    const localEstimatedWeight = this.frtOnlineBookShipmentForm.controls['inputEstimatedWeight'].value;
    const formMoveDate = this.frtOnlineBookShipmentForm.get('moveDate').value;
    console.log(localEstimatedWeight);
    this.shipmentInfo.weight = localEstimatedWeight;
    if(!this.isOneTimeShipment)this.calculateAndUpdateResults(formMoveDate, true);
    this.validatePackagesBasedOnWeight();
  }

  validatePackagesBasedOnWeight() {
    this.frtShipmentPackageService.getShipmentPackagesByShipmentDetailsId(this.shipmentInfo.frtShipmentDetailsEntity.frtShipmentDetailsId)
      .pipe(takeWhile(() => this.observer$.value)).subscribe((packages: any) => {
      this.hazmatInd = false;
      if (AppConstants.isNotNullCondition(packages) && packages.length > 0) {
        let totalPackagesWeight = 0;
        packages.forEach(shipmentPackage => {
          totalPackagesWeight += shipmentPackage.packageWeight;
          if (shipmentPackage.hazmatIndicator == 1) {
            this.hazmatInd = true;
          }
        });
        if(totalPackagesWeight === this.shipmentInfo.weight) this.packagesExist = true;
        else this.packagesExist = false;
      }
    }, (error: any) => {
      this.alertService.error('Error retrieving FRT Shipment Package records');
    });
  }

  calculateAndUpdateResults(moveDate, moveDateChanged) {
    const inputPayload = new FrtShopRatesIn();
    inputPayload.pickupDate = moveDate;
    inputPayload.estimatedMileage = this.shipmentInfo.miles;
    inputPayload.estimatedWeight = this.shipmentInfo.weight;
    inputPayload.estimatedCuFt = this.shipmentInfo.shipmentCubicFeet;
    inputPayload.rateId = this.shipmentInfo.frtShipmentsCostInfoEntity != null ? this.shipmentInfo.frtShipmentsCostInfoEntity.rateId : null;
    inputPayload.carrierId = this.carrierId;
    inputPayload.originId = this.originId;
    inputPayload.destinationId = this.destinationId;
    inputPayload.sroId = this.shipmentInfo.sroMasterId;
    inputPayload.sroType = this.shipmentInfo.ratesSroMasterEntity.sroType;
    inputPayload.accessorials = [];
    if (inputPayload.sroType && inputPayload.sroType.indexOf('Fleet Line Vehicles') >= 0) {
      this.isFleet = true;
      if (this.shipmentInfo.vehicleType === 'Category I') {
        inputPayload.autoCategory = 'Fleet Vehicles - Class 1';
      } else if (this.shipmentInfo.vehicleType === 'Category II') {
        inputPayload.autoCategory = 'Fleet Vehicles - Class 2';
      }
      if (this.shipmentInfo.vehicleType === 'Category III') {
        inputPayload.autoCategory = 'Fleet Vehicles - Class 3';
      }
      inputPayload.numberOfVehicles = this.shipmentInfo.noOfFleetVehicles;
    }
    if (this.originId && this.destinationId) {
      this.loader.show();
      this.bookShipmentService.getFrtCalculatedResults(inputPayload).pipe(takeWhile(() => this.observer$.value))
        .subscribe(results => {
          if (results !== null && results !== undefined) {
            this.shipmentCostInfo.linehaulCost = results.linehaulCostFinal;
            this.shipmentCostInfo.fuelSurchargeCost = results.fuelSurchargeCost;
            this.shipmentCostInfo.totalCost = parseFloat(results.totalCost) + this.accessorialCost;
            this.linehaulCalculation = results.linehaulCalculation;
            // this.validateAndConfirmShipment('Y');
          }
          this.loader.hide();
        }, _error => {
          this.loader.hide();
          this.alertService.error('Error while getting frt calculated results. Please contact system administrator.');
        }, () => {

          if (!moveDateChanged) {
            // this.alertService.success('Successfully retrieved shipment details.');
          }
          if (this.duplicateShipment === true) {
            this.alertService.warn('Successfully retrieved shipment details. Please verify addresses and financial information for the duplicated shipment');
          }
        });
    }
  }

  setUspsZipAndAccessorials() {
    const originUspsId = this.originCity !== null && this.originCity !== undefined && this.originCountry !== 'CANADA' ?
      this.ratesSroMasterService.getLocation(this.originCity, this.originZip, this.originState) :
      new Observable<any>(null);
    const destinationUspsId = this.destinationCity !== null && this.destinationCity !== undefined && this.destinationCountry !== 'CANADA' ?
      this.ratesSroMasterService.getLocation(this.destinationCity, this.destinationZip, this.destinationState) :
      new Observable<any>(null);
    forkJoin([originUspsId, destinationUspsId]).subscribe(responses => {
      this.originId = responses[0]?.uspsZipId;
      this.destinationId = responses[1]?.uspsZipId;
    }, err => {
      this.loader.hide();
      console.log('Error while getting the USPS details =>' + err);
      this.alertService.error('Error while getting the USPS address details');
    }, () => {
      this.loader.hide();
      this.getAccessorialsList(this.shipmentInfo.shipmentsInfoId);
    });
  }

  /**
   * @description checks the status of accessorials before confirming the shipment for TSP and non-oto's
   * @param isConfirm
   */
  validateConfirm(isConfirm) {
    if (this.isCarrierView && !this.isOneTimeShipment) {
      if (!this.accessorialTspStatus.every(x => x === 'Accepted') && (this.frtOnlineBookShipmentForm.get('carrierAcceptRefuseStatus').value === 'Accept')) {
        this.alertService.error('You have at least one or more accessorials that are not in Accepted status. Please select a different option to confirm the shipment.');
      } else if (this.accessorialTspStatus.some(x => x === 'Qualified') && (this.frtOnlineBookShipmentForm.get('carrierAcceptRefuseStatus').value !== 'Accept With Qualification')) {
        this.alertService.error('You have at least one qualified accessorial. Please select Accept with Qualification.');
      } else if (this.accessorialTspStatus.some(x => x === null) && (this.frtOnlineBookShipmentForm.get('carrierAcceptRefuseStatus').value === 'Accept' || this.frtOnlineBookShipmentForm.get('carrierAcceptRefuseStatus').value === 'Accept With Qualification')) {
        this.alertService.error('You have at least one or more accessorials not validated. Please validate before confirming the shipment.');
      } else {
        this.validateAndConfirmShipment(isConfirm);
      }
    } else {
      this.validateAndConfirmShipment(isConfirm);
    }
  }

  validateAndConfirmShipment(isConfirm) {
    if (isConfirm === 'Y') {
      this.loader.show();
    }
    this.nameAndAddressService.getShipmentAddresses(this.shipmentInfo.shipmentsInfoId).pipe(takeWhile(() => this.observer$.value)).subscribe(existingAddresses => {
      const addressArray: any = [];
      existingAddresses.forEach((address, i) => {
        addressArray.push(address.recordType);
      });
      this.addressValidationRecordTypes.forEach(recordType => {
        if (!addressArray.includes(recordType)) {
          this.allAddressExist = false;
          if (isConfirm === 'Y') {
            this.loader.hide();
            this.alertService.error('Missing address record');
          }
        }
      });
      if ((this.allAddressExist && isConfirm === 'Y') || (isConfirm === 'N')) {
        this.validatePackages(this.allAddressExist, isConfirm);
      }

    }, error => {
      this.loader.hide();
      console.log('There was an error retrieving address details =>' + error);
      this.alertService.error('Error retrieving address details for validation');
    });
    this.loader.hide();
  }

  validatePackages(allAddressExist, isConfirm) {
    this.frtShipmentPackageService.getShipmentPackagesByShipmentDetailsId(this.shipmentInfo.frtShipmentDetailsEntity.frtShipmentDetailsId)
      .pipe(takeWhile(() => this.observer$.value)).subscribe(packages => {
      // this.loader.hide();
      this.hazmatInd = false;
      if (AppConstants.isNotNullCondition(packages) && packages.length > 0) {
        let totalPackagesWeight = 0;
        packages.forEach(shipmentPackage => {
          totalPackagesWeight = totalPackagesWeight + shipmentPackage.packageWeight;

          if (shipmentPackage.hazmatIndicator == 1) {
            this.hazmatInd = true;
          }
        });
        if (totalPackagesWeight != this.shipmentInfo.weight && this.shipmentInfo.vehicleType === null) {
          if (isConfirm === 'Y') {
            this.loader.hide();
            this.alertService.error('Packages weight is not same as Estimated weight. Please adjust before confirm.');
          }
        } else {
          if (this.duplicateShipment === true) {
            this.alertService.error('Please validate the appropriation code in the package and confirm');
          } else {
            this.packagesExist = true;
          }
        }
      } else {
        if (isConfirm === 'Y') {
          this.loader.hide();
          this.alertService.error('Missing packages. Please add atleast one');
        }
      }
    }, (error1) => {
      this.loader.hide();
      this.alertService.error('Error retrieving FRT Shipment Package records');
    }, () => {
      if (allAddressExist && this.packagesExist && isConfirm === 'Y') {
        this.loader.hide();
        this.confirmShipment();
      }
    });
    this.loader.hide();
  }

  /**
   * @description confirm and save shipment details
   */
  confirmShipment() {
    this.modalRef = this.modalService.show(ConfirmationModalComponent);
    this.modalRef.content.question = 'By clicking “OK”, you acknowledge that you are about ' +
      'to create a binding contract with a transportation service provider (TSP). You will be held personally responsible under 31 U.S.C. ' +
      '3322 & 3333 for any improper charges or commitments resulting from your actions as a Government disbursing officer obligating ' +
      'government funds. Please contact the GSA Freight Management Program at transportation.programs@gsa.gov for information and training. ' +
      'Click “Cancel” to return to the shipment booking form.';
    this.modalRef.content.confirmText = 'OK';
    this.modalRef.content.cancelText = 'Cancel';
    this.modalRef.content.emitData.subscribe(result => {
      if (result.obj === true) {
        this.shipmentBookingStatus = BookShipmentStatus.PENDING;
        this.saveShipment('confirm');
      }
    });
  }

  /**
   * @description Navigates to the Address modal
   */
  enterAddressModal() {
    this.prepareShipmentData(null);
    this.bookShipmentService.setShipmentsObservable(this.shipmentInfo);
    const addressPath = 'bookshipmentaddresses';
    if (this.isCarrierView) {
      const initialState = {
        modalCalledFrom: 'bookShipment',
        shipmentInfoId: this.shipmentInfo.shipmentsInfoId
      };
      this.modalRef = this.modalService.show(BillofladingAddressesComponent, {initialState, class: 'modal-lg'});
    } else {
      this.router.navigate(['/', addressPath], {
        queryParams: {shipmentid: this.shipmentInfo.shipmentsInfoId}
      });
    }
  }

  /**
   * @description Navigates to the Accessorial modal
   */
  enterAccessorialModal() {
    this.prepareShipmentData(null);
    this.bookShipmentService.setShipmentsObservable(this.shipmentInfo);
    this.router.navigate(['/', 'frtshipmentaccessorials'], {
      queryParams: {shipmentsId: this.shipmentInfo.shipmentsInfoId, bookshipmentid: this.bookshipmentid, oto: this.isOneTimeShipment}
    });
  }

  /**
   * @description Navigates to Audit Trial
   */
  viewBookingAuditTrial() {
    this.router.navigate(['/', 'shipmentaudit'], {
      queryParams:
        {shipmentId: this.shipmentInfo.shipmentsInfoId, bookshipmentid: this.bookshipmentid}
    });
  }

  /**
   * @description Navigates to Bill of lading
   */
  viewBillOfLading() {
    this.router.navigate(['/', 'frtbilloflading'], {
      queryParams:
        {shipmentId: this.shipmentInfo.shipmentsInfoId}
    });
  }

  /**
   * @description Navigates to the shipment control review screen with booking status 'Cancelled'
   */
  cancelShipment() {
    const bookingStatus = this.shipmentInfo.bookShipmentsEntity.bookingStatus;
    if (bookingStatus != BookShipmentStatus.CANCELLED) {
      this.modalRef = this.modalService.show(ConfirmationModalComponent);
      this.modalRef.content.question = 'Are you sure, you want to cancel this shipment?';
      this.modalRef.content.title = 'Shipment Cancellation';
      this.modalRef.content.confirmText = 'Yes';
      this.modalRef.content.cancelText = 'No';
      this.modalRef.content.emitData.subscribe(result => {
        if (result.obj === true) {
          this.cancelBookShipment = true;
          this.disabled = true;
          this.saveShipment(null);
        }
      });
    } else {
      this.alertService.warn('Shipmemt is already in Cancelled status.');
    }
  }

  openPackageModal() {
    this.prepareShipmentData(null);
    this.bookShipmentService.setShipmentsObservable(this.shipmentInfo);
    this.frtShipmentPackageService.setEstimatedWeightFromBookShipment(this.shipmentInfo.weight);
    this.frtShipmentPackageService.setEstimatedCubicFromBookShipment(this.shipmentInfo.shipmentCubicFeet);
    this.frtShipmentPackageService.setFleetVehiclesFromBookShipment(this.shipmentInfo.noOfFleetVehicles);
    this.frtShipmentPackageService.setVehicleTypeFromBookShipment(this.shipmentInfo.vehicleType);
    this.router.navigate(['/frtpackageinfo'], {
      queryParams: {
        bookshipmentid: this.bookshipmentid,
        frtShipmentDetailsId: this.shipmentDetailsInfo.frtShipmentDetailsId,
        organizationId: this.organizationId,
        ratesSroInfo: this.getShipmentTypeBasedOnSro()
      }
    });
  }

  getShipmentTypeBasedOnSro(){
    if(this.isGSSPR) return 1;
    if(this.isFleet) return 2;
    return 3;
  }

  openHazmatModal() {
    this.modalService.show(FrtShipmentHazmatModalComponent, {class: 'modal-lg'});
  }

  openSealOrPurchaseModal(frmCtrl, modalTitle) {
    let inputDataArray;
    const outputDataArray: any = [];
    const sealNoData = this.shipmentInfo.frtShipmentDetailsEntity.frtShipmentSealNosEntity;
    const purchaseOrderData = this.shipmentInfo.frtShipmentDetailsEntity.frtShipmentPurchaseOrderEntity;
    if (frmCtrl == 'seal' && AppConstants.isNotNullCondition(sealNoData)) {
      inputDataArray = sealNoData.map(sealNoEntity => {
        return sealNoEntity;
      });
    } else if (frmCtrl == 'purchaseorder' && AppConstants.isNotNullCondition(purchaseOrderData)) {
      inputDataArray = purchaseOrderData.map(poEntity => {
        return poEntity;
      });
    }
    const initialState = {
      inputData: inputDataArray,
      title: modalTitle,
      isCarrierView: this.isCarrierView,
      name: frmCtrl
    };
    this.bsModalRef = this.modalService.show(FrtShipmentSealPurchaseComponent, {initialState, class: 'modal-lg'});
    this.bsModalRef.content.action.subscribe((data) => {
      if (frmCtrl == 'seal') {
        data.map(item => {
          if (AppConstants.isNotNullCondition(item.text)) {
            const frtShipmentSealNos = new FrtShipmentSealNos();
            frtShipmentSealNos.frtShipmentSealNosId = item.id;
            frtShipmentSealNos.sealNumber = item.text;
            outputDataArray.push(frtShipmentSealNos);
          }
        });
        this.shipmentInfo.frtShipmentDetailsEntity.frtShipmentSealNosEntity = outputDataArray;
      } else if (frmCtrl == 'purchaseorder') {
        data.map(item => {
          if (AppConstants.isNotNullCondition(item.text)) {
            const frtShipmentPurchaseOrder = new FrtShipmentPurchaseOrder();
            frtShipmentPurchaseOrder.frtShipmentPurchaseOrderId = item.id;
            frtShipmentPurchaseOrder.purchaseOrderNumber = item.text;
            outputDataArray.push(frtShipmentPurchaseOrder);
          }
        });
        this.shipmentInfo.frtShipmentDetailsEntity.frtShipmentPurchaseOrderEntity = outputDataArray;
      }
    });
  }

  /**
   * @description when the accept/refuse booking drop down selection changes
   */
  acceptRefuseBookingChanged(value) {
    if (value == 'Accept With Qualification' || value == 'Refuse') {
      this.acceptRejectionWithReason = true;
      this.frtOnlineBookShipmentForm.controls['carrierRefuseOption'].clearValidators();
      this.frtOnlineBookShipmentForm.controls['carrierAcceptOption'].clearValidators();
      if (value == 'Accept With Qualification') {
        this.isAcceptedWithQualificationByCarrier = true;
        this.frtOnlineBookShipmentForm.controls['carrierAcceptOption'].setValidators([Validators.required]);
      } else {
        this.isAcceptedWithQualificationByCarrier = false;
        this.frtOnlineBookShipmentForm.controls['carrierRefuseOption'].setValidators([Validators.required]);
      }
    } else if (value == 'Accept') {
      this.acceptRejectionWithReason = false;
    }
    this.frtOnlineBookShipmentForm.controls['carrierAcceptOption'].updateValueAndValidity();
    this.frtOnlineBookShipmentForm.controls['carrierRefuseOption'].updateValueAndValidity();
  }

  /**
   * @description when the accept reasons drop down selection changes
   */
  acceptedWithQualificationReasonChanged(value) {
    this.frtOnlineBookShipmentForm.controls['carrierAcceptReason'].clearValidators();
    if(value === this.carrierAcceptOptions[6]){
      this.acceptSpecifyReason = true;
      this.frtOnlineBookShipmentForm.controls['carrierAcceptReason'].setValidators([Validators.required]);
    }else{
      this.acceptSpecifyReason = false;
      this.frtOnlineBookShipmentForm.controls['carrierAcceptReason'].clearValidators();
    }
    this.frtOnlineBookShipmentForm.controls['carrierAcceptReason'].updateValueAndValidity();
    if (value === this.bookShipmentInfo.refusalOrQualificationReason) {
      this.frtOnlineBookShipmentForm.controls['carrierAcceptReason'].setValue(this.bookShipmentInfo.refusalOrQualificationRemarks);
    } else {
      this.frtOnlineBookShipmentForm.controls['carrierAcceptReason'].setValue('');
    }

  }

  /**
   * @description when the reject reasons drop down selection changes
   */
  refusedReasonChanged(value) {
    // this.rejectSpecifyReason = true;
    this.frtOnlineBookShipmentForm.controls['carrierRefuseReason'].clearValidators();
    if(value === this.carrierRejectOptions[7]){
      this.rejectSpecifyReason = true;
      this.frtOnlineBookShipmentForm.controls['carrierRefuseReason'].setValidators([Validators.required]);
    }else{
      this.rejectSpecifyReason = false;
      this.frtOnlineBookShipmentForm.controls['carrierRefuseReason'].clearValidators();
    }
    this.frtOnlineBookShipmentForm.controls['carrierRefuseReason'].updateValueAndValidity();

    if (value === this.bookShipmentInfo.refusalOrQualificationReason) {
      this.frtOnlineBookShipmentForm.controls['carrierRefuseReason'].setValue(this.bookShipmentInfo.refusalOrQualificationRemarks);
    } else {
      this.frtOnlineBookShipmentForm.controls['carrierRefuseReason'].setValue('');
    }
  }

  onGetInitData(){
    return JSON.stringify(this.frtOnlineBookShipmentForm.getRawValue());
  }

  onComparedFormChanges(){
    return _.isEqual(this.initFormData, this.finalFormData);
  }

  // initValueForBookedStatus(){
  //   if(this.bookShipmentInfo.bookingStatus === BookShipmentStatus.BOOKED){
  //     this.initFormData = this.onGetInitData();
  //     this.onValidationChangesOfForm();
  //     this.disabledConfirm = true;
  //     console.log(this.disabledConfirm);
  //     console.log(this.disabledConfirm || this.disabled ||(this.frtOnlineBookShipmentForm.invalid && !this.isCarrierView));
  //   }
  // }

  isFirstChange:boolean = false;
  onValidationChangesOfForm(){
    this.frtOnlineBookShipmentForm.valueChanges.subscribe(x => {

      if(!this.isFirstChange){
        this.initFormData = this.onGetInitData();
        this.isFirstChange = true;
      }
      this.finalFormData = this.onGetInitData();
      this.disabledConfirm = (!this.onComparedFormChanges()) ? false: true;

    });
  }

  ngOnDestroy(): void {
    this.observer$.next(false);
  }

}
